var map = {
	"./amex.png": 940,
	"./diners.png": 941,
	"./discover.png": 942,
	"./jcb.png": 943,
	"./maestro.png": 1167,
	"./mastercard.png": 944,
	"./stripe.png": 945,
	"./union.png": 946,
	"./unknown.png": 622,
	"./visa.png": 947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1166;